import { Autocomplete, Button, ToggleButton, styled } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import { APP_BACKGROUND_COLOR,APP_COLOR,APP_HOVER_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const useStyles = makeStyles({
  customTextField: {
    "& input": {
      fontFamily: FONT_FAMILY,
    },
  },
});

export const UsernameSelectField = styled(Autocomplete)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#cbd2e0",
      borderWidth: 2,
      height: 57,
    },
    "&:hover fieldset": {
      borderColor: "#cbd2e0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#cbd2e0",
    },
  },
});

export const ModalButton = styled(Button)({
  marginTop: 16,
  padding: 8,
  width: 110,
  textTransform: "none",
  color: "black",
  "&:hover": {
    backgroundColor: APP_HOVER_COLOR,
  },
  backgroundColor: APP_COLOR,
});

export const autoCompleteStyle = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#cbd2e0",
      borderWidth: 2,
    },
    "&:hover fieldset": {
      borderColor: "#cbd2e0",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#cbd2e0",
    },
  },
};

export const autoCompleteErrorStyle = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "red",
      borderWidth: 2,
    },
    "&:hover fieldset": {
      borderColor: "red",
    },
    "&.Mui-focused fieldset": {
      borderColor: "red",
    },
  },
};

export const ToggleButtonCustomized = styled(ToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: APP_COLOR,
  },
});

export const styles = {
  submitButton: {
    textTransform: "none",
    color: "black",
    "&:hover": {
      backgroundColor: APP_HOVER_COLOR,
    },
    backgroundColor: APP_COLOR,
    marginY: 3,
    paddingY: 1,
    height: 50,
  } as const,
  mintNftTitle: {
    fontFamily: FONT_FAMILY,
    fontSize: 20,
    fontWeight: "bold",
  } as const,
  bpmContainer: {
    backgroundColor: APP_BACKGROUND_COLOR,
    color: TEXT_COLOR,
    marginBottom: 0,
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
  } as const,
  genreLabel: {
    fontSize: 16,
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
  } as const,
};
